import { create } from 'zustand';
import i18n from 'i18n';
import { ProfileApi, SendCodeToEmailRequest, SendCodeResponse, ApiUtils } from '@shared/api';

interface UseSendCodeToEmailStore {
  data: SendCodeResponse | null;
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  send: (request: SendCodeToEmailRequest) => void;
  clear: () => void;
}

export const useSendCodeToEmailStore = create<UseSendCodeToEmailStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  success: null,

  send: async (request: SendCodeToEmailRequest) => {
    try {
      set({ loading: true, data: null, error: null, success: null });
      const result = await ProfileApi.sendCodeToEmail(request);
      set({ loading: false, data: result, success: true });
      return { loading: false, data: result, success: true };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null, success: null }),
}));
